import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import'swiper/css/swiper.css'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import './directive'
import './style/index.scss'
Vue.use(VueAwesomeSwiper)
Vue.use(Viewer)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
